"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import { BookletCategory, BookletDate } from "@/@types";
import BookletsCategoryCard from "./BookletsCategoryCard";
import BookletsDateCard from "./BookletsDateCard";

type Props = {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  categories: BookletCategory[];
  bookletsDate: BookletDate;
};

export default function BookletFilterCard({
  isMenuOpen,
  toggleMenu,
  categories,
  bookletsDate,
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [showMenuIcon, setShowMenuIcon] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowMenuIcon(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMobile && isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isMobile, isMenuOpen]);

  return (
    <div>
      {!isMobile && (
        <div className="space-y-4">
          <BookletsCategoryCard categories={categories} />
          <BookletsDateCard bookletsDate={bookletsDate} />
        </div>
      )}

      {isMobile && !isMenuOpen && showMenuIcon && (
        <button
          onClick={toggleMenu}
          className="fixed bottom-5 left-5 bg-yellow-500 text-white p-4 rounded-full shadow-lg z-50"
        >
          <Image
            src="/assets/icons/filter.svg"
            alt="Filtros"
            width={20}
            height={20}
            className="h-5 w-5"
          />
        </button>
      )}

      {isMobile && isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-end z-50"
          onClick={toggleMenu}
        >
          <div
            className="w-full bg-white p-6 rounded-t-2xl shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end">
              <button
                onClick={toggleMenu}
                className="text-2xl font-bold text-gray-500 hover:text-black"
              >
                ✕
              </button>
            </div>
            <div className="mt-4">
              <BookletsCategoryCard categories={categories} />
            </div>
            <div className="mt-4">
              <BookletsDateCard bookletsDate={bookletsDate} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
